const bonusTypes = ["PROFIT_BOOST", "ODDS_BOOST_PERCENTAGE", "ODDS_BOOST_FIXED", "ODDS_BOOST_EXTENSION", "GUARANTEED_PAYOUT"];
export function isBoostPlayerBonus(bonus) {
    return Boolean(bonus && bonusTypes.includes(bonus.type));
}
export function isGuaranteedPayoutBonus(bonus) {
    return Boolean(bonus && bonus.type === "GUARANTEED_PAYOUT");
}
//# sourceMappingURL=isBoostPlayerBonus.js.map